<template>
  <div id="app">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a class="navbar-item">
          <router-link to="/">
            <img src="./assets/logo.png" />
          </router-link>
        </a>
        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          @click="showMenu = !showMenu"
          :class="{ 'is-active' : showMenu }"
          data-target="navbarBasicExample"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" class="navbar-menu" :class="{ 'is-active' : showMenu }">
        <div class="navbar-start">
          <router-link to="/competitionslist">
            <a class="navbar-item" @click="showMenu = false">Current competitions</a>
          </router-link>
          <router-link to="/previouscompetitionslist">
            <a class="navbar-item" @click="showMenu = false">History</a>
          </router-link>
          <router-link to="/about">
            <a class="navbar-item" @click="showMenu = false">About</a>
          </router-link>
        </div>
      </div>
    </nav>
    <hr style="margin:0 !important;" />
    <div class="container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  data() {
    return {
      showMenu: false
    };
  }
};
</script>

<style>
#app {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
}

.navbar-item {
  height: 100%;
  color: #000;
}
</style>
